import { render, staticRenderFns } from "./AdmissaoForm.vue?vue&type=template&id=50d70560&"
import script from "./AdmissaoForm.vue?vue&type=script&lang=js&"
export * from "./AdmissaoForm.vue?vue&type=script&lang=js&"
import style0 from "./AdmissaoForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AdmissaoForm.vue"
export default component.exports